import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

const CustomSelect = ({ 
  value, 
  onChange, 
  options = [], 
  placeholder = "Selecione...",
  className = "",
  style = {},
  disabled = false,
  autoSelectSingle = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const selectedOption = options.find(opt => opt.value === value);
  const displayText = selectedOption ? selectedOption.label : placeholder;

  useEffect(() => {
    if (!autoSelectSingle || disabled || typeof onChange !== "function") return;

    const hasValue = value !== undefined && value !== null && String(value) !== "";
    if (hasValue) return;

    const validOptions = options.filter(
      (opt) => !opt?.disabled && opt?.value !== undefined && opt?.value !== null && String(opt.value) !== ""
    );

    if (validOptions.length === 1) {
      onChange({ target: { value: validOptions[0].value } });
    }
  }, [autoSelectSingle, disabled, onChange, options, value]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (optionValue) => {
    if (disabled) return;
    onChange({ target: { value: optionValue } });
    setIsOpen(false);
  };

  return (
    <div className={`custom-select ${className}`} ref={selectRef} style={style}>
      <div 
        className={`custom-select__trigger ${isOpen ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={() => { if (!disabled) setIsOpen(!isOpen); }}
        style={{ cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.7 : 1, ...style }}
      >
        <span className={!selectedOption ? 'placeholder' : ''}>
          {displayText}
        </span>
        <ChevronDown 
          size={12} 
          style={{ 
            transition: 'transform 0.2s',
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0)'
          }} 
        />
      </div>

      {isOpen && !disabled && (
        <div className="custom-select__dropdown">
          {options.map((option) => {
            const optDisabled = Boolean(option.disabled);
            return (
              <div
                key={option.value}
                className={`custom-select__option ${value === option.value ? 'selected' : ''} ${optDisabled ? 'disabled' : ''}`}
                onClick={() => {
                  if (optDisabled) return;
                  handleSelect(option.value);
                }}
                aria-disabled={optDisabled}
              >
                {option.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default CustomSelect;
